import {REQUEST_POSTFIX, SERVER_API_PREFIX, SUCCESS_POSTFIX} from 'new-constants/api.constants';
import {FetchMessageState} from './fetch-message.reducer.types';

const initialState: FetchMessageState = {};

export const fetchMessageReducer = (previousState = initialState, action): FetchMessageState => {

	const dismissMessage = action.dismissMessage || action.payload?.dismissMessage;
	if (dismissMessage) {
		previousState = {
			...previousState,
			[dismissMessage]: null,
		};
	}

	if (!action.type.startsWith(SERVER_API_PREFIX)) {
		return previousState;
	}

	if (action.type.endsWith(REQUEST_POSTFIX)) {
		const fetchConstant = action.type.replace(REQUEST_POSTFIX, '');

		return {
			...previousState,
			[fetchConstant]: null,
		};
	}

	if (action.type.endsWith(SUCCESS_POSTFIX) && action.payload?.messages) {
		const fetchConstant = action.type.replace(SUCCESS_POSTFIX, '');

		return {
			...previousState,
			[fetchConstant]: action.payload.messages,
		};
	}

	return previousState;
};
